import type { SensorsLocale } from "@/locales/fr/sensors";

const sensorsLocale: SensorsLocale = {
  sensors: {
    title: "Temperature sensors",
    sensor: "Sensor",
    sensors: "Sensors",
    temperatureSensor: "Temperature Sensor",
    temperatureSensors: "Temperature Sensors",
    activeInSite: "Active in site",
    nSensorsSent: "{n} Sensors sent",
    linkedToSensors: "Linked to sensors",
    sentByCustomerServer: "Sent by Customer Servicer",
    request: "Request for the shipment of sensors",
    noModulators: "No equipment is installed on-site",
    noModulatorsWarning:
      "No equipment is installed on-site. It is not possible to request the shipment of sensors to a site without existing equipment.",
    beforeShipment: "Before any shipment of sensors:",
    beforeShipmentList: `
            <li>Send temperature sensors only if necessary (after diagnosis)</li>
            <li>Verify the postal address, main phone number, and email address</li>
            <li>The equipment is shipped within 5 business days to the address provided on VoltaCall</li>
            <li>The member must have a smartphone with a working camera and the updated MyVoltalis app</li>
            <li>In the package, the member will find a brief set of instructions for installing the sensors</li>
        `,
    form: {
      number: "Number of sensors to ship",
      rooms: "Select devices concerned by the shipment",
    },
  },
};

export default sensorsLocale;
